import { deepClone } from 'paliari-js-utils'

export const defaultStoreImports = {
  state: ['query'],
  actions: ['fetchList'],
  mutations: ['setPage', 'setQuery'],
  getters: ['filtered', 'loading'],
}

export default {
  data() {
    return { q: {} }
  },
  methods: {
    close() {
      this.$router.back()
    },
    onFilter() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
      this.close()
    },
    clearFilter(query = {}) {
      this.q = { ...query }
      this.onFilter()
    }
  },
  created() {
    this.q = Object.assign(this.q, { ...this.query })
  }
}
